<template>
    <el-dialog
        :visible="dialogVisible"
        :append-to-body="true"
        :destroy-on-close="true"
        :show-close="false"
        width="950px"
        class="vip-unauth-alert"
        custom-class="vip-unauth-alert"
        @close="close"
    >   
        <div class="text-content">
            <button class="close-btn" aria-label="关闭" @click="close">×</button>
            <div class="title-box"><img src="https://prodimg.global-dsc.cn/dgzz_img/tupiao/title.png" style="width: 28px;height: 28px;margin-right: 10px;"><h2 class="modal-title">如何获取超级会员权限</h2></div>
            <div style="padding-right: 300px;position: relative;line-height: 38px;padding-bottom: 20px;">
                <!-- <span style="font-size: 26px;margin-bottom: 30px;display: block;">超级会员权限</span> -->
                 <div class="content-item">
                    <div class="order">1</div>
                    <div>直接致电该零部件供应商负责人，告知他们尽快加入全国供应链平台，以便让更多的选型和采购工程师找到他们，该供应商正式加入平台后，您的账号将转为超级会员；</div>
                </div>
                 <div class="content-item">
                    <div class="order">2</div>
                    <div>在本软件首页点击右上角的“推荐有礼”，推荐任意一家您熟悉的尚未入驻平台的供应商，准确填写联系信息，平台确认有效后，您的账号将转为超级会员；</div>
                </div>
                 <div class="content-item">
                    <div class="order">3</div>
                    <div>使用本软件企业版，以企业名义正式注册，上传必要的证明资料，进行正确企业认证，审核通过后，您的企业账号将转为超级会员；</div>
                </div>
                 <div class="content-item">
                    <div class="order">4</div>
                    <div>若以上三条都不能做到，则可以直接扫码缴费成为超级会员,费用199元，有效期为五年。</div>
                </div>
                 <div class="content-item">
                    <div class="order">5</div>
                    <div>成为超级会员，即可自动成为平台的供应商推荐人，推荐人可以点击下方“报备须知”按钮，详细了解如何报备自己推荐的供应商，该供应商一旦正式加入平台，推荐人以向供应商提供技术支持和服务的方式每年可获取平台支付的服务费，成为平台兼职推广员。</div>
                </div>
                <div class="vip-qrcode">
                    <div class="vip-qrcodeview" v-loading="loading" 
                    style="border-radius: 20px;padding: 8px;background: white;box-shadow: 0 4px 10px -4px rgb(0 27 65 / 8%), 0 0 0 1px rgb(37 99 235 / 12%);width: 200px;">
                        <div class="nvip-qrcode" v-show="yearQrBol">
                            <!-- <span style="font-size: 22px;font-weight: bold;margin-bottom: 10px;">199元/年</span> -->
                            <canvas id="nvipQrcode" width="160" height="160"></canvas>
                        </div>
                        <div class="jdvip-qrcode" v-show="quarterQrBol">
                            <!-- <span style="font-size: 22px;font-weight: bold;margin-bottom: 10px;">79元/季度</span> -->
                            <canvas id="jdvipQrcode" width="160" height="160"></canvas>
                        </div>
                    </div>
                    <p style="margin-top: 10px;">微信扫码，成为超级会员</p>
                    <div style="display:flex; align-items:center; justify-content:center; gap:5px; margin:4px 0 2px;">
                        若有相关需求或其他问题
                    </div>
                    <p>请加微信: 19564151511</p>
                    <!-- <div class="add-weixin">请加微信19564151511</div> -->
                    <div style="display:flex; align-items:center; justify-content:center; gap:5px; margin:4px 0 2px;margin-top:20px;">
                        相互支持
                    </div>
                    <div style="display:flex; align-items:center; justify-content:center; gap:5px; margin:4px 0 2px;">
                        共建可信数字供应链平台
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <!-- <el-button
                size="medium"
                type="default"
                round
                @click="cancel"
            >联系客服</el-button> -->
            <div style="display: flex;justify-content: space-between;padding-right: 60px;">
                <div>
                    <span class="footer-btn" style="margin-right: 20px;"  @click="cancel">联系客服</span>
                    <span class="footer-btn" style="margin-right: 20px;" @click="goRegsiter">了解企业注册</span>
                    <span class="footer-btn" style="margin-right: 20px;" @click="gobbxz">报备须知</span>
                    <span class="footer-btn" @click="_downZip">下载企业版</span>
                    
                </div>
                <div>
                    <span class="primery-btn"  @click="confirm">我知道了</span>
                </div>
           </div>
            <!-- <el-button
                size="medium"
                type="primary"
                round
               
            >支付完成</el-button> -->
        </template>
    </el-dialog>
</template>

<script>
import UQRCode from 'uqrcodejs';
import {Message} from 'element-ui'
import {Category} from '@digital-supply-chain/module'
import { ChatService, TodaySearchService } from '@/service';
import {WinForm} from '@/libs'

  export default {
    data() {
        this.quarterQr = null;
        this.yearQr = null;
        return {
            dialogVisible: false,
            loading: false,

            yearQrBol: false,
            quarterQrBol: false,
        };
    },
    methods: {
        open() {
            this.createMemberOrder();
            this.dialogVisible = true;
        },
        close() {
			this.dialogVisible = false;
		},
		cancel() {
            ChatService.StartRecent(Category.User, 221992398939168);
		},
		confirm() {
            this.close();
		},
        goRegsiter() {
            WinForm.md.openUrl('https://ne.global-dsc.cn/dggjent.html');
        },
        gobbxz() {
            WinForm.md.openUrl('https://ne.global-dsc.cn/html/ykt.html');
        },
        _downZip() {
            WinForm.md.openUrl('https://down.global-dsc.cn/Release/dggje/dggjEnt.zip');
        },

        async createMemberOrder() {
            this.loading = true;
            const res = await TodaySearchService.createMemberOrderList();
            this.loading = false;
            if (res.code == 0) {
                const yearOrder = res.data.find(item => item.vip.type == 'year');
                const quarterOrder = res.data.find(item => item.vip.type == 'quarter');
                const option = { margin: 8 };

                if (yearOrder) {
                    this.yearQrBol = true;
                    this.yearQr = new UQRCode();
                    this.yearQr.data = yearOrder.payUrl;
                    this.yearQr.size = 160;
                    this.yearQr.setOptions(option);
                    this.yearQr.make();
                    const yearCanvas = document.getElementById("nvipQrcode");
                    const yearCanvasContext = yearCanvas.getContext("2d");
                    this.yearQr.canvasContext = yearCanvasContext;
                    this.yearQr.drawCanvas();
                }

                if (quarterOrder) {
                    this.quarterQrBol = true;
                    this.quarterQr = new UQRCode();
                    this.quarterQr.data = quarterOrder.payUrl;
                    this.quarterQr.size = 160;
                    this.quarterQr.setOptions(option);
                    this.quarterQr.make();
                    const quarterCanvas = document.getElementById("jdvipQrcode");
                    const quarterCanvasContext = quarterCanvas.getContext("2d");
                    this.quarterQr.canvasContext = quarterCanvasContext;
                    this.quarterQr.drawCanvas();
                }
            }
        },
    }
  };
</script>

<style lang="less">
    .vip-unauth-alert{
        .close-btn {
            position: absolute;
            top: 20px;
            right: 28px;
            width: 34px;
            height: 34px;
            border-radius: 40px;
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(2px);
            border: 1px solid rgba(59, 130, 246, 0.2);
            color: #4a658a;
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
            z-index: 5;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
        }
        .close-btn:focus {
            outline: none;
            box-shadow: none;
        }
        .close-btn:hover {
            background: #f0f7ff;
            color: #1e4bd2;
            border-color: #90b4f0;
            transform: scale(1.03);
        }
        .modal-title {
            font-size: 26px;
            font-weight: 600;
            letter-spacing: -0.3px;
            color: #0b1e3a;
            margin-bottom: 10px;
            margin-top: 0;
            display: flex;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
            flex: 1;
        }
        .title-box {
            display: flex;
            align-items: center;
            border-bottom: 1.5px solid rgba(59, 130, 246, 0.18);
            margin-bottom: 20px;
        }
       
        .content-item {
            display: flex;
            align-items: baseline;
            color: #1a2a44;
            margin-bottom: 0;
            line-height: 30px;
            margin-bottom: 10px;
            .order {
                display: inline-block;
                min-width: 28px;
                height: 28px;
                background: linear-gradient(145deg, #ecf3ff, #d9e9ff);
                border-radius: 30px;
                text-align: center;
                line-height: 28px;
                font-weight: 650;
                font-size: 13px;
                color: #1d4ed8;
                box-shadow: 0 2px 6px rgba(37, 99, 235, 0.06), 0 0 0 1px rgba(59, 130, 246, 0.1);
                border: 1px solid #ffffffb0;
                margin-right: 10px;
            }
        }


        .text-content{
            font-size: 16px;
            line-height: 30px;
        }
        &.el-dialog{
            // background: #ecf5ff;
            background: #fff;
            border: 1px solid #b3d8ff;
            border-radius: 28px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02), 0 0 0 1px rgba(59, 130, 246, 0.12);
            border: 1px solid rgba(148, 188, 230, 0.22);
        }
        .el-dialog__header{
            padding: 0;
        }
        .el-dialog__body{
            padding-top: 24px;
            padding-bottom: 0;
        }
        .el-dialog__footer{
            text-align: center;
            width: 100%;
            display: block;
        }
        .el-dialog__headerbtn{
            top: 10px;
            right: 10px;
            font-size: 20px;
        }

        .vip-qrcode{
            width: 280px;
            position: absolute;
            right: 0px;
            top: 0px;
            line-height: 26px;
            font-size: 14px;

            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            background: rgba(248, 251, 255, 0.75);
            backdrop-filter: blur(4px);
            padding: 18px 14px 14px;
            border-radius: 24px;
            box-shadow: inset 0 1px 3px #ffffff, 0 0 0 1px rgba(59, 130, 246, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.7);
            align-self: center;
            p{
                width: 100%;
                margin: 0;
                padding: 0 40px;
                text-align: center;
            }
            .add-weixin {
                color: #0f2b62;
                background: rgba(37, 99, 235, 0.04);
                padding: 2px 10px;
                border-radius: 30px;
                display: inline-block;
                margin: 5px 0 3px;
                font-size: 14px;
                border: 1px solid rgba(59, 130, 246, 0.1);
            }
        }
        .vip-qrcodeview{
            width: 100%;
            height: 196px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
        }
        .nvip-qrcode,.jdvip-qrcode{
            width: 230px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .footer-btn {
            padding: 9px 22px;
            border-radius: 50px;
            border: 1.5px solid rgba(37, 99, 235, 0.22);
            background: rgba(255, 255, 255, 0.9);
            backdrop-filter: blur(2px);
            color: #1e3a8a;
            font-size: 14px;
            font-weight: 540;
            cursor: pointer;
            transition: all 0.2s;
            box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);
            display: inline-flex;
            align-items: center;
            gap: 8px;

            &:hover {
                background: #f0f7ff;
                border-color: #3b82f6;
                box-shadow: 0 6px 12px -6px rgba(37, 99, 235, 0.2);
                transform: translateY(-1px);
                color: #0b2b6e;
            }
        }
        .primery-btn {
            padding: 10px 34px;
            border-radius: 50px;
            border: none;
            background: linear-gradient(145deg, #1e4bd2, #2563eb);
            color: white;
            font-size: 15px;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.25s;
            margin-left: auto;
            box-shadow: 0 8px 16px -6px #1e4bd280, 0 0 0 1px rgba(255, 255, 255, 0.2) inset;
            display: flex;
            align-items: center;
            gap: 6px;
            border: 1px solid rgba(255, 255, 255, 0.1);
            &:hover {
                background: linear-gradient(145deg, #2563eb, #3b82f6);
                box-shadow: 0 12px 20px -8px #1e4bd2, 0 0 0 2px rgba(37, 99, 235, 0.15) inset;
                transform: scale(1.01);
            }
        }
    }
</style>
